export const twitterScript = () => {
  // twitter Script
  window.twttr = (function(d, s, id) {
    var js,
      fjs = d.getElementsByTagName(s)[0],
      t = window.twttr || {};
    if (d.getElementById(id)) return t;
    js = d.createElement(s);
    js.id = id;
    js.src = "https://platform.twitter.com/widgets.js";
    fjs.parentNode.insertBefore(js, fjs);

    t._e = [];
    t.ready = function(f) {
      t._e.push(f);
    };

    return t;
  })(document, "script", "twitter-wjs");
};

export const fbScript = () => {
  // facebook Script

  let script = document.createElement("script");
  let root = document.createElement("div");
  let btn = document.createElement("div");
  let body = document.querySelector(".btn__share-pane .facebook");
  root.setAttribute("id", "fb-root");
  btn.setAttribute(
    "data-href",
    process.env.ENV == "local" ? "http://itftennis.com" : location.href
  );
  btn.classList.add("fb-share-button");
  script.innerHTML = `(function(d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.0";
        fjs.parentNode.insertBefore(js, fjs);

      })(document, "script", "facebook-jssdk");`;

  if (body !== null) {
    body.appendChild(root);
    body.appendChild(script);
    body.appendChild(btn);
  }
};

export const weiboScript = () => {
  // weibo Script

  let btn = document.createElement("button");
  let body = document.querySelector(".btn__share-pane .weibo");
  let url = process.env.ENV == "local" ? "http://itftennis.com" : location.href;

  btn.innerHTML = `Weibo`;
  btn.onclick = () => {
    window.open(
      `http://service.weibo.com/share/share.php?url=${url}&appkey=&title=Checkout out this link: ${url}&pic=&ralateUid=`,
      "popUpWindow",
      "height=360,width=660,left=center,top=centet,resizable=no,scrollbars=no,toolbar=no,menubar=no,location=no,directories=no, status=yes"
    );
  };

  if (body !== null) {
    body.appendChild(btn);
  }
};

export const linkedInScript = () => {
  // linkedIn Script

  let script = document.createElement("script");
  let context = document.createElement("script");

  let body = document.querySelector(".btn__share-pane .linkedIn");

  script.setAttribute("src", "https://platform.linkedin.com/in.js");
  script.setAttribute("type", "text/javascript");
  script.innerHTML = `lang: en_US`;

  context.setAttribute(
    "data-url",
    process.env.ENV == "local" ? "http://itftennis.com" : location.href
  );
  context.setAttribute("type", "IN/Share");

  if (body !== null) {
    body.appendChild(script);
    body.appendChild(context);
  }
};
